import { render, staticRenderFns } from "./Interface.vue?vue&type=template&id=6146c50a&"
import script from "./Interface.vue?vue&type=script&lang=js&"
export * from "./Interface.vue?vue&type=script&lang=js&"
import style0 from "./Interface.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports